import request from "../../utils/request";

// 查询用户列表
export function listGroup(params) {
  return request({
    url: '/api/user/group/',
    method: 'get',
    params: params
  })
}